import { For, Show } from 'solid-js'

import { useI18n } from '../../i18n'
import { formatDistance } from './measurementFormat'

type GroupByChipsProps = {
   options: number[]
   value: number | null
   onChange: (group: number | null) => void
}

/**
 * Renders the "All · 2 km · 5 km" chips derived from logged distances.
 *
 * @param props - The options, active group, and change handler.
 * @returns The chip row, or nothing when there is fewer than one option.
 */
const GroupByChips = (props: GroupByChipsProps) => {
   const t = useI18n()

   /**
    * Returns chip classes for a selected/unselected state.
    *
    * @param selected - Whether the chip is active.
    * @returns The class string.
    */
   const chipClass = (selected: boolean) =>
      `px-3 py-1 rounded-full text-xs border transition ${
         selected ?
            'border-accent-strong bg-accent-strong/20 text-ink'
         :  'border-edge bg-surface-raised text-ink-secondary hover:bg-surface-control'
      }`

   return (
      <Show when={props.options.length > 0}>
         <div class="flex flex-wrap items-center gap-2" id="measurement-group-chips">
            <span class="text-xs text-ink-muted">{t('Distance')}</span>
            <button
               type="button"
               class={chipClass(props.value === null)}
               onClick={() => props.onChange(null)}
            >
               {t('All')}
            </button>
            <For each={props.options}>
               {option => (
                  <button
                     type="button"
                     class={chipClass(props.value === option)}
                     onClick={() => props.onChange(option)}
                  >
                     {formatDistance(option, 1)}
                  </button>
               )}
            </For>
         </div>
      </Show>
   )
}

export default GroupByChips
